<template>
	<div class="download-tool">
		<template v-if="items.length >= multiSelectMinNum">
			<DownloadMultiSelect
				:headline="headline"
				:buttonText="buttonText"
				:items="items"
				:headingLevel="headingLevel"
				:orderLitURL="orderLitURL"
				:errorMessage="errorMessage"
				:lockContent="returnBoolean(lockContent)"
				:lockMessage="lockMessage"
				:contentBefore="contentBefore"
				:contentAfter="contentAfter"
				:selectAll="returnBoolean(selectAll)"
				:lightFontTheme="returnBoolean(lightFontTheme)"
			/>
		</template>
		<template v-else>
			<DownloadSingleSelect
				:headline="headline"
				:buttonText="buttonText"
				:items="items"
				:orderLitURL="orderLitURL"
			/>
		</template>
	</div>
</template>

<script>
import DownloadMultiSelect from "./DownloadMultiSelect.vue";
import DownloadSingleSelect from "./DownloadSingleSelect.vue";

export default {
	name: "DownloadTool",
	components: { DownloadMultiSelect, DownloadSingleSelect },
	data() {
		return {
			multiSelectMinDefault: 3
		};
	},
	props: {
		multiSelectMin: {
			type: [Number, String],
			validator: function (value) {
				return !isNaN(value);
			}
		},
		headline: {
			type: String
		},
		lockContent: {
			type: [Boolean, String],
			default: true
		},
		lockMessage: {
			type: String,
			default: "You must register or sign in to access this PDF"
		},
		buttonText: {
			type: String
		},
		items: {
			type: Array,
			required: true
		},
		headingLevel: {
			type: [Number, String],
			validator: function (value) {
				return !isNaN(value);
			}
		},
		orderLitURL: {
			type: String
		},
		errorMessage: {
			type: String
		},
		contentBefore: {
			type: String,
			default: ""
		},
		contentAfter: {
			type: String,
			default: ""
		},
		selectAll: {
			type: [Boolean, String],
			default: true
		},
		lightFontTheme: {
			type: [Boolean, String],
			default: false
		}
	},
	computed: {
		multiSelectMinNum() {
			return !isNaN(this.multiSelectMin)
				? Number(this.multiSelectMin)
				: this.multiSelectMinDefault;
		}
	},
	methods: {
		returnBoolean(prop) {
			return prop === true ? true : prop === "true" ? true : false;
		}
	}
};
</script>
